var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { attrs: { "no-gutters": "" } },
    [
      _c(
        "v-col",
        { attrs: { cols: "4" } },
        [
          _c(
            "v-card",
            {
              staticClass: "pt-1 pb-1 pl-3 confirm-card",
              attrs: { outlined: "", tile: "" }
            },
            [
              _c("label", { staticClass: "detail-data--label" }, [
                _vm._v(_vm._s(_vm.detailLabel))
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-col",
        { attrs: { cols: "8" } },
        [
          _c(
            "v-card",
            {
              staticClass: "pt-1 pb-1 pl-3 confirm-card",
              attrs: { outlined: "", tile: "" }
            },
            _vm._l(_vm.detailValue, function(data) {
              return _c("div", { key: _vm.detailLabel + "-" + data }, [
                _vm.isHtml
                  ? _c("label", {
                      staticClass: "detail-data--value",
                      domProps: { innerHTML: _vm._s(data) }
                    })
                  : _c("label", { staticClass: "detail-data--value" }, [
                      _vm._v(_vm._s(data))
                    ])
              ])
            }),
            0
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63dc21b3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63dc21b3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contract_form/DetailDataSingleLabel.vue
// module id = 7xFe
// module chunks = 1